module.exports = __webpack_public_path__ + "static/media/SomeButton.dae0e18f.svg";